const LocaleModule = {

  state: {
    locale: {}
  },

  getters: {
    locale (state) {
      return state.locale
    }
  },

  mutations: {
    setLocale (state, payload) {
      state.locale = payload
    }
  },

  actions: {
    setLocale ({ commit }, payload) {
      commit('setLocale', payload)
    }
  },

  modules: {
  }

}

export default LocaleModule
